module.exports = __webpack_public_path__ + "static/media/bug.6983f735.svg";